import fetch, { Response } from 'node-fetch';

import { IStrapiPageSection } from 'types';

export async function getJson<T>(route: string): Promise<T> {
  const url = `${process.env.GATSBY_API_URL}${route}`;
  console.log('Fetching:', url);
  const res: Response = await fetch(url);
  return res.json();
}

export function getSectionByKey(key: string, sections?: Array<IStrapiPageSection>): IStrapiPageSection | undefined {
  return sections ? sections.find((section) => section.__component === key) : undefined;
}
